import React, { useState, useEffect, useRef } from 'react';
import { delay } from '../utils';

const MessageBox = React.forwardRef((props, ref) => {
  const [closing, setClosing] = useState();
  const mounted = useRef();
  const { message, yesNo, classes, width, area, background, fontSize, onReply } = props;
  const cls = `message ${closing ? 'fadeout' : 'fadein-fast'} ${classes || ''}`;

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const handleClick = () => {
    if (yesNo) {
      return;
    }

    dismiss();

    if (onReply) {
      onReply();
    }
  };

  const handleAnswer = yes => {
    dismiss();

    if (onReply) {
      onReply(yes);
    }
  };

  const dismiss = () => {
    setClosing(true);

    delay(() => {
      if (mounted.cuurent) {
        setClosing(false);
      }
    });
  };

  const style = yesNo ? { padding: '20px 15px', cursor: 'initial' } : { padding: '20px' };

  if (background) {
    style.background = background;
  }

  if (fontSize) {
    style.fontSize = fontSize;
  }

  return (
    <div style={{ display: 'grid', gridArea: `${area || '1/1/span 2/2'}`, width: width, height: '100%', zIndex: 2 }}>
      <div ref={ref} className={cls} onClick={handleClick} style={style}>
        {message}
        {yesNo ? (
          <div style={{ color: 'orange', marginTop: '10px', textAlign: 'center' }}>
            <span style={{ cursor: 'pointer' }} onClick={() => handleAnswer(true)}>
              Yes
            </span>
            <span style={{ cursor: 'pointer', marginLeft: '20px' }} onClick={() => handleAnswer(false)}>
              No
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
});

export default MessageBox;
